import { render } from "./CustomCollapse.vue?vue&type=template&id=ba5dc0ae&scoped=true"
import script from "./CustomCollapse.vue?vue&type=script&lang=js"
export * from "./CustomCollapse.vue?vue&type=script&lang=js"

import "./CustomCollapse.vue?vue&type=style&index=0&id=ba5dc0ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba5dc0ae"]])

export default __exports__